import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    GeneralBlockBody,
    GeneralBlockHeader,
    GeneralBlockTitle,
    GeneralBlockValue,
} from 'src/registry/components/blocks/GeneralBlock';
import { ICON_MAP } from 'src/utils/constants';
import { cn } from 'src/utils/shadcn';

export interface SidePanelAttributeProps {
    label: string;
    value?: string;
    link?: string;
    className?: string;
}

const SidePanelAttribute = ({ label, value, link, className }: SidePanelAttributeProps) => {
    return (
        <div className={cn('flex flex-row gap-2', className)}>
            <GeneralBlockHeader variant="dashboard">
                <GeneralBlockTitle>{label}</GeneralBlockTitle>
            </GeneralBlockHeader>

            <GeneralBlockBody variant="dashboard">
                <GeneralBlockValue
                    size="small"
                    className={cn('break-all', link && value && 'text-primary-700 font-medium')}
                >
                    {link && value ? (
                        <Link to={link}>
                            {value}
                            <FontAwesomeIcon
                                icon={ICON_MAP.ARROW_UP_RIGHT}
                                className="text-primary-700 pl-1 font-medium"
                            />
                        </Link>
                    ) : (
                        (value ?? '-')
                    )}
                </GeneralBlockValue>
            </GeneralBlockBody>
        </div>
    );
};

export default SidePanelAttribute;
